import React from 'react';
import { ReferenciaCabecera } from '../../../interfaces/ReferenciaCabecera';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Breadcrumb from '../../atoms/breadcrumb/breadcrumb';
import { GatsbyImage } from "gatsby-plugin-image";
import './headboardMap.scss';


const HeadboardMap = ( props:ReferenciaCabecera ) => {
  const data = props[0];

   return (
      <div className={`o-headboard-map ${data.videoBackground ? 'o-headboard-map--video' : ''}`} >
         { data.tituloPrincipal &&
            <h1 className='o-headboard-map__title' >{data.tituloPrincipal}</h1>
         }
         <div className={`o-headboard-map__cover ${data.videoBackground ? 'o-headboard-map__cover--video' : ''}`} >
            {
               data.videoBackground ?
                  <video className="o-headboard-map__cover__video" id="video-loop" muted loop autoPlay>
                     <source src={data.videoBackground.file.url} type=" video/webm"/>
                     Your browser does not support the video tag.
                  </video>
               :
                  ( data.imagenBackground.gatsbyImageData ?
                     <GatsbyImage
                        className="o-headboard-map__cover__img"
                        image={data.imagenBackground.gatsbyImageData}
                        alt={data.imagenBackground.title || "imagen cabecera botones"}
                     />
                  :
                     <img  className='o-headboard-map__cover__img'
                        src={ data.imagenBackground.file.url }
                        alt={ data.imagenBackground && data.imagenBackground.title || "imagen cabecera" }
                        loading="lazy"
                     />
                  )
            }
         </div>
         <div className='o-headboard-map__breadcrumb' >
            <Breadcrumb content = { data.migaDePan } mapHeader />
         </div>
         <div className={`o-headboard-map__center ${data.videoBackground ? 'o-headboard-map__center--video' : ''}`} >
            {
               !data.videoBackground &&
               ( data.imagenHeader.gatsbyImageData ?
                  <GatsbyImage
                     className="o-headboard-map__center__img"
                     image ={data.imagenHeader.gatsbyImageData}
                     alt={data.imagenHeader.title || "imagen cabecera botones"}
                  />
               :
                  <img className='o-headboard-map__center__img'
                     src={ data.imagenHeader.file.url }
                     alt={ data.imagenHeader.title || "imagen cabecera" }
                     loading="lazy"
                  />
               )
            }
            { data.tituloSpan &&
               <span className='o-headboard-map__center__subt'>
                  { data.tituloSpan }
               </span>
            }
            { data.descripcion &&
               <p className='o-headboard-map__center__desc'>
                  {documentToReactComponents(props[0].descripcion.json)}
               </p>
            }
         </div>
      </div>
   )
}

export default HeadboardMap;
